<app-nugget-preview [url]="url" [docHeight]="docHeight" [viewerType]="viewerType" [cloudStorage]="true">
</app-nugget-preview>
